<script>
import Card from 'primevue/card';
// import LabelField from '../../generic/LabelField.vue';
    import Utils from '../../../common/Utils';

export default{
    props: ['title', 'columns'],
    components: {
        Card //, LabelField
    },
    data(){
        return {
            results: {
                shellTemperature: null
            }
        }
    },
    methods: {
      loadResults(data){
        if(data){
          this.results = data;
        }
      },
      getResults(){
        return this.results;
      }
    },
    computed: {
        utils(){
            return Utils;
        },
    }
};
</script>

<template>
    <Card>
        <template #subtitle>
            {{title}}
        </template>
        <template #content>
            <div class="grid formgrid" >
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatInteger(results.totalVolume)" :label="$t('calculatorTankDevelopment.volLordo')"/> -->
                  <label>{{$t('calculatorTankDevelopment.volLordo')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.totalVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatInteger(results.waterVolume)" :label="$t('calculatorTankDevelopment.volAcqua')"/> -->
                  <label>{{$t('calculatorTankDevelopment.volAcqua')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.waterVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>
                <!-- <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <LabelField :value="results.netVolume" :label="$t('calculatorTankDevelopment.volLordoH2o')"/>
                </div> -->
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatInteger(results.roofVolume)" :label="$t('calculatorTankDevelopment.volTetto')"/> -->
                  <label>{{$t('calculatorTankDevelopment.volTetto')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.roofVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatDecimal(results.f54, 4)" :label="$t('calculatorTankDevelopment.coeffFX54')"/> -->
                  <label>{{$t('calculatorTankDevelopment.coeffFX54')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.f54" :minFractionDigits="4" :maxFractionDigits="4" />
                </div>              
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatInteger(results.volume15)" :label="$t('calculatorTankDevelopment.vol15')"/> -->
                  <label style="font-weight:bold">{{$t('calculatorTankDevelopment.vol15')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.volume15" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatInteger(results.totalWeight)" :label="$t('calculatorTankDevelopment.pesoGiacenza')"/> -->
                  <label style="font-weight:bold">{{$t('calculatorTankDevelopment.pesoGiacenza')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.totalWeight" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>


                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatDecimal(results.shellTemperature,2)" :label="$t('calculatorTankDevelopment.tempMant')"/> -->
                  <label>{{$t('calculatorTankDevelopment.tempMant')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.shellTemperature" :minFractionDigits="2" :maxFractionDigits="2" />
                </div>
                <!-- <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <LabelField :value="results.deltaTemperature" :label="$t('calculatorTankDevelopment.deltaTemp')"/>
                </div> -->
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatDecimal(results.thermalExpansionFactor,5)" :label="$t('calculatorTankDevelopment.coeffDilatTerm')"/> -->
                  <label>{{$t('calculatorTankDevelopment.coeffDilatTerm')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.thermalExpansionFactor" :minFractionDigits="5" :maxFractionDigits="5" />
                </div>
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatInteger(results.netVolume)" :label="$t('calculatorTankDevelopment.volNetto')"/> -->
                  <label>{{$t('calculatorTankDevelopment.volNetto')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.netVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatDecimal(results.f56,4)" :label="$t('calculatorTankDevelopment.coeffFX56')"/> -->
                  <label>{{$t('calculatorTankDevelopment.coeffFX56')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.f56" :minFractionDigits="4" :maxFractionDigits="4" />
                </div>

                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatInteger(results.productLevel)" :label="$t('calculatorTankDevelopment.livelloApieno')"/> -->
                  <label>{{$t('calculatorTankDevelopment.livelloApieno')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.productLevel" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatInteger(results.removableVolume)" :label="$t('calculatorTankDevelopment.volEstraib')"/> -->
                  <label>{{$t('calculatorTankDevelopment.volEstraib')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.removableVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatInteger(results.removableWeight)" :label="$t('calculatorTankDevelopment.pesoEstraib')"/> -->
                  <label>{{$t('calculatorTankDevelopment.pesoEstraib')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.removableWeight" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>

                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatInteger(results.steamVolume)" :label="$t('calculatorTankDevelopment.volVapore')"/> -->
                  <label>{{$t('calculatorTankDevelopment.volVapore')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.steamVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}">
                  <!-- <LabelField :value="utils.formatInteger(results.steamWeight)" :label="$t('calculatorTankDevelopment.pesoVapore')"/> -->
                  <label>{{$t('calculatorTankDevelopment.pesoVapore')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.steamWeight" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>

                
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}" v-if="results.isBiofeed">
                  <label>{{$t('calculatorTankDevelopment.volumeExpansionFactor')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.volumeExpansionFactor" :minFractionDigits="3" :maxFractionDigits="3" />
                </div>
                
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}" v-if="results.isBiofeed">
                  <label>{{$t('calculatorTankDevelopment.weightCorrectionFactorBiofeed')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.biofeedWeightCorrectiornFactor" :minFractionDigits="6" :maxFractionDigits="6" />
                </div>
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}" v-if="results.isBiofeed">
                  <label>{{$t('calculatorTankDevelopment.roofWeight')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.roofWeight" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>
                <div :class="{'col-12 field': true, 'lg:col-4':columns == 3, 'lg:col-6':columns == 2}" v-if="results.isBiofeed">
                  <label>{{$t('calculatorTankDevelopment.vacuumWeight')}}</label>
                  <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.vacuumWeight" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>
            </div>
        </template>
    </Card>
</template>